import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import { CONTROLLER_CONFIG, CONTROLLER_ORDER } from '@/lib/controllerConfig';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

function ControllerTypeFilter({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  return (
    <FilterMenu label="Controller" submenu={submenu}>
      <DropdownMenuItem onClick={() => removeSearchParam('controllerType')}>
        All
      </DropdownMenuItem>
      {CONTROLLER_ORDER.map((controller) => (
        <DropdownMenuItem
          key={controller}
          onClick={() => appendSearchParam('controllerType', controller)}
        >
          {CONTROLLER_CONFIG[controller].name}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default ControllerTypeFilter;
